enum FieldAlias {
  ORGANIZATION_URL = "organizationUrl",
  ORGANIZATION_NAME = "organizationName",
  ORGANIZATION_PARTICIPANT_TYPES = "organizationParticipantTypes",
  WORK_EMAIL = "workEmail",
  SOCIAL_BUYER = "socialBuyer",
  ORGANIZATION_LOGO = "organizationLogo",
  LOCATION_AND_SECTOR = "eventLocationId",
  BULK_TICKET_QUANTITY = "numberOfTicketsToPurchase",
  LOCATION_ACTION_SHORTCUT = "locationActionShortcut" // this is used only in UI to show label with link for event organization screen
}

export default FieldAlias;
